import { useState, useEffect } from 'react';
import {
  Modal,
  Fade,
  Backdrop,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider
} from '@material-ui/core';
import PropTypes from 'prop-types';
import CompanyAdminTable from './CompanyAdminTable';
import useVrackApi from '../../hooks/useVrackApi';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  p: 4
};

CompanyAdminsModal.propTypes = {
  isOpen: PropTypes.bool,
  closeHandler: PropTypes.func,
  companyId: PropTypes.string,
  companyName: PropTypes.string
};

export default function CompanyAdminsModal({ isOpen, closeHandler, companyId, companyName }) {
  const [admins, setAdmins] = useState([]);

  // Backend exposes /companies/{company_id}/users with an optional ?role=admin
  const fetchAdminsApi = useVrackApi('get', `/companies/${companyId}/users`);

  useEffect(() => {
    if (isOpen) {
      fetchAdmins();
    }
    // eslint-disable-next-line
  }, [companyId, isOpen]);

  const fetchAdmins = async () => {
    try {
      const data = await fetchAdminsApi.fetchData({ params: { role: 'admin' } });
      setAdmins(data);
      return data;
    } catch (error) {
      console.error('Failed to get list of company admins ', error.message);
    }
    return [];
  };

  return (
    <Modal
      open={isOpen}
      sx={{ outline: 'none' }}
      onClose={closeHandler}
      aria-labelledby="company-admins-modal"
      aria-describedby="modal to display company admins"
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={isOpen}>
        <Grid direction="row" sx={style} container>
          <Grid item xs={12} md={1} lg={3} onClick={closeHandler} />
          <Grid item xs={12} md={10} lg={6}>
            <Card>
              <CardHeader sx={{ padding: 2 }} title={`${companyName || companyId} Admins`} />
              <Divider />
              <CardContent sx={{ paddingTop: 1 }}>
                <CompanyAdminTable
                  admins={admins}
                  updateAdmins={fetchAdmins}
                  companyId={companyId}
                  showHeader
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={1} lg={3} onClick={closeHandler} />
        </Grid>
      </Fade>
    </Modal>
  );
}
